const text = value => typeof value === 'string' && value.trim() ? value.trim() : null;

// Preserve the date and clock recorded on the event, not the browser's timezone.
export const accountLinkSchedule = link => {
  const raw = text(link.event_date);
  const match = raw?.match(/^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2})(?::\d{2}(?:\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?)?$/);
  let date = 'Date unavailable';
  if (match) {
    const parsed = new Date(`${match[1]}T00:00:00Z`);
    if (!Number.isNaN(parsed.valueOf()) && parsed.toISOString().slice(0, 10) === match[1]) {
      date = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(parsed);
    }
  }
  const clock = text(link.event_time) || match?.[2];
  const timeParts = clock?.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
  let time = 'Time unavailable';
  if (timeParts) {
    const hours = Number(timeParts[1]), minutes = Number(timeParts[2]), period = timeParts[3]?.toUpperCase();
    if (minutes < 60 && (period ? hours >= 1 && hours <= 12 : hours <= 23)) {
      const offset = !text(link.event_time) ? match?.[3] : null;
      const zone = offset ? offset === 'Z' || ['+00:00', '+0000'].includes(offset) ? 'UTC' : `UTC${offset}` : text(link.event_timezone);
      time = `${hours % 12 || 12}:${timeParts[2]} ${period || (hours >= 12 ? 'PM' : 'AM')} · ${zone || 'Time zone unavailable'}`;
    }
  }
  return { date, time };
};

export const accountLinkFormat = link => text(link.event_format) || ({ 'match-play': 'Match Play', skins: 'Skins', 'stroke-play': 'Stroke Play' }[link.game_type]) || 'Format unavailable';